const API_BASE_URL = process.env.REACT_APP_BASE_API_URL

export const createLead = async (payload, role) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_BASE_URL}/${role}/lead/leads`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('[createLead] Ошибка создания лида:', errorData);
            console.log(response.status)
            throw { ...errorData, statusCode: response.status };
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('[createLead] Ошибка сети:', error);
        console.log(error)
        throw error;
    }
};